/**
 * SHA-256 souboru v prohlížeči, malými hex znaky: týž tvar jako serverový `sha256Hex`
 * (`apps/api/src/lib/hash.ts`) a `Sha256HexSchema`. Dávka ho počítá z PŮVODNÍHO souboru (před
 * zmenšením), aby kontrola duplicit našla i fotku nahranou zmenšenou (`originalContentHash`).
 * `crypto.subtle` je jen v bezpečném kontextu (HTTPS, localhost); admin běží na obou.
 */
export async function sha256File(file: Blob): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", await file.arrayBuffer());
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("");
}
